<template>
<div>
  <md-app-toolbar id="navbar" class="md-dense md-primary" md-elevation="3" md-theme="toolbar">
    <div class="md-toolbar-section-start">
      <md-button
        v-if="type === 'filter' && $store.state.screenSize !== 'desktop'"
        @click="toggleSidebar">
        <md-icon>filter_list</md-icon>
        <span style="margin-left:15px">{{ $t('filter') }}</span>
      </md-button>
      <md-button
        v-else-if="$store.state.screenSize !== 'desktop'"
        @click="toggleSidebar">
        <md-icon>menu</md-icon>
        <span style="margin-left:15px">{{ $t('overview') }}</span>
      </md-button>
      <router-link :to="{name: 'start'}" class="mr-3">
        <img v-if="$store.state.user.client.logo" ref="logo" class="logo md-small-hide" />
        <img v-else src="../assets/logo-white.png" class="logo md-small-hide" />
      </router-link>
    </div>
    <div class="md-toolbar-section-end">

      <md-field
        v-if="$store.state.user.clients && $store.state.user.clients.length > 1 && $store.state.user.role === 'admin'"
        style="width:275px"
        class="md-xsmall-hide mr-2">
        <md-select
          v-model="clientId"
          :disabled.sync="$store.state.loading"
          @md-selected="onClientChange"
          id="client"
          name="client">
          <md-option v-for="client in $store.state.user.clients" :key="client._id" :value="client._id">{{ client.label }}</md-option>
        </md-select>
      </md-field>

      <md-button
        v-if="$store.state.user.role === 'admin' && $store.state.screenSize === 'xsmall'"
        class="md-icon-button mr-2"
        @click="showClientsDialog = true">
        <md-icon>folder_shared</md-icon>
      </md-button>

      <md-button
        v-if="$store.state.user.role === 'admin'"
        @click="$store.dispatch('postSync')"
        :disabled.sync="$store.state.loading"
        :title="$t('sync')"
        class="md-icon-button md-xsmall-hide md-small-hide md-medium-hide mr-2">
        <md-icon>sync</md-icon>
      </md-button>

      <!--md-button class="md-icon-button md-xsmall-hide md-small-hide md-medium-hide mr-2" title="Upload"
        @click="showUploadDialog = true">
        <md-icon>unarchive</md-icon>
      </md-button-->

      <md-menu md-size="small">
        <md-button
          md-menu-trigger
          :disabled.sync="$store.state.loading"
          :title="$t('more')"
          class="md-icon-button">
          <md-icon>more_vert</md-icon>
        </md-button>
        <md-menu-content>
          <md-subheader>{{ $store.state.user.email }}</md-subheader>
          <md-menu-item @click="logout()">
            <md-icon>exit_to_app</md-icon>
            <span class="md-list-item-text">{{ $t('logout') }}</span>
          </md-menu-item>
        </md-menu-content>
      </md-menu>
    </div>
  </md-app-toolbar>

  <dialog-modal
    v-if="$store.state.user.role === 'admin' && $store.state.screenSize === 'xsmall'"
    type="clients"
    :onClientChange="onClientChange"
    :showClientsDialog.sync="showClientsDialog" />

  <!--dialog-modal
    type="upload"
    :showUploadDialog.sync="showUploadDialog"
  /-->

</div>
</template>

<script>

export default {
  name: 'NavBar',
  props: {
    type: String
  },
  data: () => ({
    clientId: '',
    sidebarActive: false,
    showClientsDialog: false
    // showUploadDialog: false
  }),
  mounted () {
    const client = this.$store.state.user.client
    if (client && client.logo) {
      this.$store.dispatch('getFile', client.logo)
        .then(image => {
          const $el = this.$refs.logo
          $el.src = image
        })
        .catch(err => console.error(err))
    }
  },
  updated () {
    const $vm = this
    if ($vm.$store.state.user && $vm.$store.state.user.client) $vm.clientId = $vm.$store.state.user.client._id
  },
  methods: {
    logout () {
      this.$auth.logout()
    },
    toggleSidebar () {
      this.$store.dispatch('setSidebarActive', !this.sidebarActive)
    },
    onClientChange (clientId) {
      const $vm = this
      if (clientId && clientId !== $vm.$store.state.user.client._id) {
        const client = $vm.$store.state.user.clients.find(client => client._id === clientId)
        $vm.$store.dispatch('setClient', client)
        $vm.$router.replace({ name: 'start' })
        location.reload()
      }
    }
  }
}
</script>

<style lang="scss">
@import "../styles/theme";

#navbar {
  height: $navbar-height;
}

.badge {
  width: 19px;
  height: 19px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 8px;
  right: 8px;
  background: $red;
  border-radius: 100%;
  color: #fff;
  font-size: 10px;
  font-style: normal;
  font-weight: 600;
  letter-spacing: -.05em;
}

// All drop downs need a higher index
// Otherwise they appear behind the dialog
.md-menu-content {
  z-index: 9999 !important;
}

// Remove space from title and tabs in app toolbar
.md-toolbar .md-title {
  margin-left: 0;
}
.md-toolbar .md-tabs {
  padding-left: 0;
}

// Change color and height of tabs indicator in toolbar
.md-tabs.md-theme-toolbar.md-primary .md-tabs-indicator {
  height: 4px;
}

#app .logo {
  height: 46px;
  margin-right: 16px;
}
</style>
